import { waveGraphQLFetch } from "./graphql/httpClient.js";
import { WAVE_GRAPHQL } from "./graphql/queries.js";
import { parseCommentParticipantSubs } from "./waveCommentMentions.js";
import { isSameParticipantSub } from "./wavePresence.js";
async function pushGql(cfg, query, variables, key) {
    const token = await cfg.getIdToken();
    return waveGraphQLFetch({
        endpoint: cfg.endpoint,
        idToken: token,
        query,
        variables,
        resultKey: key,
    });
}
export async function registerPushDevice(cfg, input) {
    return pushGql(cfg, WAVE_GRAPHQL.registerPushDevice, { input }, "registerPushDevice");
}
export async function unregisterPushDevice(cfg, input) {
    return pushGql(cfg, WAVE_GRAPHQL.unregisterPushDevice, { input }, "unregisterPushDevice");
}
export async function enqueueWaveNotification(cfg, input) {
    return pushGql(cfg, WAVE_GRAPHQL.enqueueWaveNotification, { input }, "enqueueWaveNotification");
}
function waveDeepLink(waveId, spaBase) {
    const base = (spaBase ?? "").replace(/\/+$/, "");
    if (base)
        return `${base}/w/${waveId}`;
    return `wave://wave/${waveId}`;
}
/** Best-effort push enqueue — never throws to callers. */
export async function enqueueWaveNotificationBestEffort(cfg, input) {
    try {
        await enqueueWaveNotification(cfg, input);
    }
    catch (err) {
        console.warn("[Wave push] enqueue failed", err);
    }
}
export async function notifyWaveInvitePush(cfg, opts) {
    await enqueueWaveNotificationBestEffort(cfg, {
        waveId: opts.waveId,
        kind: "invite",
        targetSubs: [opts.recipientSub],
        payload: {
            waveId: opts.waveId,
            title: "Invito Wave",
            body: `${opts.inviterLabel} ti ha invitato in «${opts.waveTitle}»`,
            deepLink: waveDeepLink(opts.waveId, opts.spaBase),
        },
    });
}
export async function notifyWaveChatMentionPush(cfg, opts) {
    const mentioned = parseCommentParticipantSubs(opts.body, opts.participants).filter((sub) => !isSameParticipantSub(sub, opts.currentUserSub));
    if (!mentioned.length)
        return;
    await enqueueWaveNotificationBestEffort(cfg, {
        waveId: opts.waveId,
        kind: "chat_mention",
        targetSubs: mentioned,
        payload: {
            waveId: opts.waveId,
            title: opts.waveTitle,
            body: `${opts.authorLabel} ti ha menzionato in chat: ${opts.body.slice(0, 120)}`,
            deepLink: waveDeepLink(opts.waveId, opts.spaBase),
        },
    });
}
export async function notifyWaveCommentMentionPush(cfg, opts) {
    const mentioned = parseCommentParticipantSubs(opts.body, opts.participants).filter((sub) => !isSameParticipantSub(sub, opts.currentUserSub));
    if (!mentioned.length)
        return;
    await enqueueWaveNotificationBestEffort(cfg, {
        waveId: opts.waveId,
        kind: "comment_mention",
        targetSubs: mentioned,
        payload: {
            waveId: opts.waveId,
            title: opts.waveTitle,
            body: `${opts.authorLabel} ti ha menzionato in un commento: ${opts.body.slice(0, 120)}`,
            deepLink: waveDeepLink(opts.waveId, opts.spaBase),
        },
    });
}
export async function notifyWaveChangePush(cfg, opts) {
    await enqueueWaveNotificationBestEffort(cfg, {
        waveId: opts.waveId,
        kind: "wave_change",
        payload: {
            waveId: opts.waveId,
            title: opts.waveTitle,
            body: opts.detail,
            deepLink: waveDeepLink(opts.waveId, opts.spaBase),
        },
    });
}
